[<RequireQualifiedAccess>]
module Shared.Infrastructure.DateOnly

open System

let toString (date: DateOnly) : string =
    date.ToDateTime(TimeOnly(0, 0)).ToString("dd.MM.yyyy")

let toShortString (date: DateOnly) : string =
    date.ToDateTime(TimeOnly(0, 0)).ToString("dd.MM.yy")